import { upsertHistory, getUserHistory } from '../util/api';

export const UPSERT_HISTORY_REQUEST = 'app/history/UPSERT_HISTORY_REQUEST';
export const UPSERT_HISTORY_SUCCESS = 'app/history/UPSERT_HISTORY_SUCCESS';
export const UPSERT_HISTORY_ERROR = 'app/history/UPSERT_HISTORY_ERROR';

export const FETCH_HISTORY_REQUEST = 'app/history/FETCH_HISTORY_REQUEST';
export const FETCH_HISTORY_SUCCESS = 'app/history/FETCH_HISTORY_SUCCESS';
export const FETCH_HISTORY_ERROR = 'app/history/FETCH_HISTORY_ERROR';

export const initialState = {
  isSubmitting: false,
  submitSuccess: false,
  error: null,
  watchedVideos: [],
  isFetching: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPSERT_HISTORY_REQUEST:
      return { ...state, isSubmitting: true, error: null };
    case UPSERT_HISTORY_SUCCESS:
      return { ...state, isSubmitting: false, submitSuccess: true, error: null };
    case UPSERT_HISTORY_ERROR:
      return { ...state, isSubmitting: false, submitSuccess: false, error: payload };
    case FETCH_HISTORY_REQUEST:
      return { ...state, isFetching: true, fetchError: null };
    case FETCH_HISTORY_SUCCESS:
      return { ...state, isFetching: false, watchedVideos: payload, fetchError: null };
    case FETCH_HISTORY_ERROR:
      return { ...state, isFetching: false, fetchError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const upsertHistoryRequest = () => ({ type: UPSERT_HISTORY_REQUEST });
export const upsertHistorySuccess = () => ({ type: UPSERT_HISTORY_SUCCESS });
export const upsertHistoryError = error => ({ type: UPSERT_HISTORY_ERROR, payload: error });

export const fetchHistoryRequest = () => ({ type: FETCH_HISTORY_REQUEST });
export const fetchHistorySuccess = history => ({ type: FETCH_HISTORY_SUCCESS, payload: history });
export const fetchHistoryError = error => ({ type: FETCH_HISTORY_ERROR, payload: error });

// ================ Thunks ================ //

export const upsertHistoryData = state => {
  return {
    isSubmitting: state.history.isSubmitting,
    submitSuccess: state.history.submitSuccess,
    error: state.history.error,
  };
};

export const fetchHistoryData = state => {
  return {
    watchedVideos: state.history.watchedVideos,
    isFetching: state.history.isFetching,
    fetchError: state.history.fetchError,
  };
};

export const upsertHistoryAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(upsertHistoryRequest());
  try {
    const result = await upsertHistory(params);
    dispatch(upsertHistorySuccess());
    return result;
  } catch (error) {
    console.error('Error upserting history:', error);
    dispatch(upsertHistoryError(error.message || 'Failed to save history'));
    throw error;
  }
};

export const fetchHistoryAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchHistoryRequest());
  try {
    const result = await getUserHistory(params);
    dispatch(fetchHistorySuccess(result.history || []));
    return result;
  } catch (error) {
    console.error('Error fetching history:', error);
    dispatch(fetchHistoryError(error.message || 'Failed to fetch history'));
    throw error;
  }
};
